export default "__VITE_ASSET__Cy$1Ncg6__"